import { render, staticRenderFns } from "./goodMoments.vue?vue&type=template&id=ead8a736&"
import script from "./goodMoments.vue?vue&type=script&lang=js&"
export * from "./goodMoments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports